// extracted by mini-css-extract-plugin
export var acitonButtons = "_g7-0";
export var additionalIcon = "_g7-f";
export var block = "_g7-1";
export var blockContent = "_g7-7";
export var blockDescription = "_g7-8";
export var blockIcon = "_g7-9";
export var blockTitle = "_g7-6";
export var border = "_g7-a";
export var center = "_g7-l";
export var edge = "_g7-b";
export var edgeLabel = "_g7-c";
export var edgePath = "_g7-d";
export var error = "_g7-e";
export var flowchart = "_g7-g";
export var flowchartContent = "_g7-h";
export var highlighted = "_g7-3";
export var hover = "_g7-4";
export var icon = "_g7-i";
export var left = "_g7-m";
export var navButton = "_g7-j";
export var navButtons = "_g7-k";
export var right = "_g7-n";
export var selected = "_g7-2";
export var small = "_g7-5";